import * as _ from 'lodash';
import { CommonConstants } from '../shared';

// Function to calculate word count and character count for track changes deletions
export function calculateTrackChangesDeletionCount(editor) {
  // Get the data from the editor
  const data = editor.getData();

  // Initialize counts for deletions
  let deletionWordCount = 0;
  let deletionCharCount = 0;

  // Define a regular expression pattern to match text between the <suggestion-start> and <suggestion-end> tags
  const pattern =
    /<suggestion-start\s+name="deletion:[^"]*"><\/suggestion-start>(.*?)<suggestion-end\s+name="deletion:[^"]*">/gs;

  // Use matchAll() to find all occurrences of the pattern in the data
  const matches = data.matchAll(pattern);

  // Helper function to count words and characters
  function countWordsAndCharacters(text) {
    // Count words
    const cleanedText = text?.trim().replace(/<\/?[^>]+(>|$)/g, '');

    const wordCount = cleanedText?.match(/([a-zA-Z0-9À-ž]+\S?)+/gu)?.length;
    // Count characters
    const charCount = cleanedText.length;
    return { wordCount, charCount };
  }

  // Iterate over each match and extract the text content
  for (const match of matches) {
    // match[1] contains the text content between the tags
    const textBetweenTags = match[1];

    // Calculate the word count and character count for the text content
    const { wordCount, charCount } = countWordsAndCharacters(textBetweenTags);

    // Add the counts to the total deletion counts
    deletionWordCount += wordCount || 0;
    deletionCharCount += charCount || 0;
  }

  // Return the deletion counts
  return {
    deletionWordCount,
    deletionCharCount,
  };
}

export function deduplicateTrackChangesInCitation(content: HTMLElement): void {
  const suggestionAttrs = [
    CommonConstants.trackchangesMarkup.SUGGESTION_START_BEFORE,
    CommonConstants.trackchangesMarkup.SUGGESTION_START_AFTER,
    CommonConstants.trackchangesMarkup.SUGGESTION_END_BEFORE,
    CommonConstants.trackchangesMarkup.SUGGESTION_END_AFTER,
    CommonConstants.trackchangesMarkup.NAME,
  ];
  _.forEach(Array.from(content.querySelectorAll('*')), (el: Element) => {
    _.forEach(suggestionAttrs, (attr) => {
      const value = el.getAttribute(attr);
      if (value && value.includes(',')) {
        const cleaned = [...new Set(value.split(','))].join(',');
        el.setAttribute(attr, cleaned);
      }
    });
  });
}
